import { searchFilterDefaults } from "../filters/filters"

export const setSearchPageState = initialValues => {
  //gotta build these objects back out
  if (initialValues === {}) {
    return searchFilterDefaults
  } else {
    //we copy the default values, then look for keys that match in the url params.
    //if we find them, we replace them here.
    let defaultState = JSON.parse(JSON.stringify(searchFilterDefaults))
    const keys = Object.keys(initialValues)
    for (const key of keys) {
      defaultState[key] = initialValues[key]
    }

    return defaultState
  }
}
